<template>
	<div>
		<v-row no-gutters class="pa-2" justify="end">
			<ExcelTemplateHelpDialog :name="'excelTemplate'" />
			<ExcelTemplateDialog
				:excel_template.sync="excel_template"
				:modelNames="modelNames"
				:departments="departments"
				:showFileInput="false"
				:disabledBaseModelSelect="true"
			/>
			<v-btn class="ml-2" color="secondary" @click="updateExcelTemplate">
				<v-icon class="mr-2">mdi-content-save</v-icon>
				保存</v-btn
			>
			<v-btn class="ml-2" color="secondary" @click="UpdateAndRedirect">
				<v-icon class="mr-2">mdi-exit-to-app</v-icon>
				保存してページを確認</v-btn
			>
		</v-row>
		<v-tabs center-active height="36">
			<template v-if="sheets.length">
				<v-tab v-for="sheet in sheets" :key="sheet.id" @click="setSheet(sheet.name)">{{
					sheet.name
				}}</v-tab>
			</template>
		</v-tabs>
		<v-row no-gutters justify="center">
			<v-progress-circular v-if="loading" :size="70" :width="7" color="primary" indeterminate />
		</v-row>
		<v-sheet class="table-wrapper" v-show="!loading">
			<div v-if="rows.length && columns.length" class="grid-container" :style="gridContainerWidth">
				<template v-for="(row, i) in rows">
					<template v-if="headers.length == row.cells.length">
						<template v-for="(cell, j) in row.cells">
							<ExcelTemplateCell
								:ref="`cell${i}-${j}`"
								v-if="cellExists(cell)"
								:key="`${i}-${j}`"
								:cell="cell"
								:hidden="row.hidden == true || columns[j].hidden == true"
								:coordinate="{ yCoordinate: i, xCoordinate: j }"
								@open-cell-dialog="openCellDialog($event)"
							/>
						</template>
					</template>
					<template v-else>
						<template v-for="(header, j) in headers">
							<ExcelTemplateCell
								:ref="`cell${i}-${j}`"
								v-if="cellExists(cellData(row.cells, header))"
								:key="`${i}-${j}`"
								:cell="cellData(row.cells, header)"
								:hidden="row.hidden == true || columns[j].hidden == true"
								:coordinate="{ yCoordinate: i, xCoordinate: j }"
								@open-cell-dialog="openCellDialog($event)"
							/>
						</template>
					</template>
				</template>
			</div>
		</v-sheet>
		<CellDialog
			v-if="isDialogOpen"
			:cell="selectedCell"
			:existingCell="existingCell"
			:coordinate="coordinate"
			:cellOptions="cellOptions"
			:originalModelColumns="originalModelColumns"
			:associationNames="associationNames"
			:sheetId="selectedSheetId"
			@close="closeCellDialog()"
			@add-cell="addCell($event)"
			@update-cell="updateCell($event)"
			@delete-cell="deleteCell($event)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import * as Excel from "exceljs"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import excelHelper from "../../helper/excelHelper"
import ExcelTemplateDialog from "./components/ExcelTemplateDialog.vue"
import ExcelTemplateHelpDialog from "../shared/HelpDialog.vue"
import CellDialog from "./components/CellDialog.vue"
import ExcelTemplateCell from "./components/ExcelTemplateCell.vue"

export default {
	components: {
		ExcelTemplateDialog,
		ExcelTemplateHelpDialog,
		CellDialog,
		ExcelTemplateCell,
	},
	data() {
		return {
			id: this.$route.params.id,
			excel_template: {
				name: null,
				base_model: null,
				exclusive_flag: false,
				department_id: null,
				file: null,
			},
			selectedSheetId: null,
			selectedCell: null,
			coordinate: null,
			existingCell: null,

			loading: true,

			isSaved: true,

			modelNames: [],
			departments: [],
			cellOptions: { formulas: [], special_types: [] },
			originalModelColumns: [],
			associationNames: [],

			workbook: null,
			headers: [],
			cells: [],
			sheets: [],
			columns: [],
			rows: [],
			mergedCells: [],
		}
	},
	mounted() {
		const headers = authenticate.setHeader()
		const url = `/erp/v1/excel_templates/${this.id}/edit`
		axios
			.get(url, { headers })
			.then((res) => {
				this.excel_template = res.data.excel_template
				this.cells = res.data.cells
				this.modelNames = res.data.base_models
				this.departments = res.data.departments
				this.excel_file = res.data.excel_file
				this.cellOptions = res.data.cell_options
				this.originalModelColumns = res.data.columns
				this.associationNames = res.data.association_names
				this.readExcelData()
			})
			.catch((err) => {
				errorHandling.errorResponse(err)
			})
	},
	beforeRouteLeave(to, from, next) {
		if (this.isSaved) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
			return
		}
		const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？")
		if (answer) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
		} else {
			next(false)
		}
	},
	methods: {
		updateExcelTemplate() {
			this.saveExcelTemplate()
				.then((res) => {
					this.excel_template = res.data.excel_template
					this.cells = res.data.cells
					this.setAllCellData()
					this.isSaved = true
					window.removeEventListener("beforeunload", this.confirmSave)
					this.$store.dispatch("setFlash", {
						text: "設定を保存しました。",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		UpdateAndRedirect() {
			this.saveExcelTemplate()
				.then((res) => {
					this.isSaved = true
					window.removeEventListener("beforeunload", this.confirmSave)
					this.$router.push({ name: "excel_template_show", params: { id: this.id } })
					this.$store.dispatch("setFlash", {
						text: "設定を保存しました。",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		saveExcelTemplate() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/excel_templates/${this.id}/`
			const excel_cells_attributes = this.cells
			return axios.patch(
				url,
				{ excel_template: { excel_cells_attributes: excel_cells_attributes } },
				{ headers }
			)
		},
		addCell(cell) {
			this.cells.push(cell)
			this.closeCellDialog()
			this.setCellData(cell)
			window.addEventListener("beforeunload", this.confirmSave)
			this.isSaved = false
		},
		updateCell(cell) {
			const originalCell = this.cells.find(
				(c) =>
					c.sheet_number == cell.sheet_number &&
					c.x_coordinate == cell.x_coordinate &&
					c.y_coordinate == cell.y_coordinate
			)
			this.removeCellData(originalCell)
			const index = this.cells.indexOf(originalCell)
			this.cells[index] = cell
			this.closeCellDialog()
			this.setCellData(cell)
			window.addEventListener("beforeunload", this.confirmSave)
			this.isSaved = false
		},
		deleteCell(cell) {
			const originalCell = this.cells.find(
				(c) =>
					c.sheet_number == cell.sheet_number &&
					c.x_coordinate == cell.x_coordinate &&
					c.y_coordinate == cell.y_coordinate
			)
			this.removeCellData(originalCell)
			if (originalCell.id) {
				this.cells.push({ id: originalCell.id, _destroy: true })
			}
			const index = this.cells.indexOf(originalCell)
			this.cells.splice(index, 1)
			this.closeCellDialog()
			window.addEventListener("beforeunload", this.confirmSave)
			this.isSaved = false
		},
		setAllCellData() {
			const cells = this.cells.filter((c) => c.sheet_number == this.selectedSheetId)
			cells.forEach((cell) => {
				this.setCellData(cell)
			})
			this.$nextTick(() => {
				this.loading = false
			})
		},
		setCellData(cell) {
			const model = this.associationNames.find((model) => cell.base_model == model.id)
			const columns = model ? model.columns : this.originalModelColumns
			const column = columns.find((c) => c.id == cell.column_name)
			let name = model ? `${column.name}(${model.name})` : column.name
			if (cell.prefix_formula) {
				const formula = this.cellOptions.formulas.find((f) => f.id == cell.prefix_formula)
				name = `${cell.prefix_number} ${formula.name} ${name}`
			} else if (cell.suffix_formula) {
				const formula = this.cellOptions.formulas.find((f) => f.id == cell.suffix_formula)
				name = `${name} ${formula.name} ${cell.suffix_number}`
			}
			if (model && model.association_type == "has_many") {
				const maxCount = cell.max_count || 10
				let skipped_cell_count = 0
				for (let i = 0; i < maxCount; i++) {
					skipped_cell_count += this.skip_cells(cell, skipped_cell_count + i)
					if (cell.array_direction == "x_axis") {
						this.appendCellData(name, cell.y_coordinate, cell.x_coordinate + skipped_cell_count + i)
					} else if (cell.array_direction == "y_axis") {
						this.appendCellData(name, cell.y_coordinate + skipped_cell_count + i, cell.x_coordinate)
					}
				}
			} else {
				this.appendCellData(name, cell.y_coordinate, cell.x_coordinate)
			}
		},
		skip_cells(cell, already_skipped_count) {
			let foundNextCell = false
			let skip_cells_count = 0
			let xCoordinate =
				cell.array_direction == "x_axis"
					? cell.x_coordinate + already_skipped_count
					: cell.x_coordinate
			let yCoordinate =
				cell.array_direction == "y_axis"
					? cell.y_coordinate + already_skipped_count
					: cell.y_coordinate

			while (foundNextCell == false) {
				// セルがこれ以上存在しない
				if (this.columns.length < yCoordinate + 1 || this.rows.length < xCoordinate + 1) {
					foundNextCell = true
					// セルが隠れている
				} else if (
					this.columns[xCoordinate]?.hidden == true ||
					this.rows[yCoordinate]?.hidden == true
				) {
					if (cell.array_direction == "x_axis") {
						xCoordinate += 1
					} else if (cell.array_direction == "y_axis") {
						yCoordinate += 1
					}
					skip_cells_count += 1
				} else {
					// セルがない、またはマージされている
					let row = this.rows[yCoordinate]
					let targetCell =
						this.headers.length == row.cells.length
							? row.cells[xCoordinate]
							: this.cellData(row.cells, this.headers[yCoordinate])
					if (!targetCell || !targetCell.master) {
						foundNextCell = true
					} else {
						if (cell.array_direction == "x_axis") {
							xCoordinate += 1
						} else if (cell.array_direction == "y_axis") {
							yCoordinate += 1
						}
						skip_cells_count += 1
					}
				}
			}
			return skip_cells_count
		},
		removeCellData(cell) {
			const model = this.associationNames.find((model) => cell.base_model == model.id)
			if (model && model.association_type == "has_many") {
				const maxCount = cell.max_count || 10
				let skipped_cell_count = 0
				for (let i = 0; i < maxCount; i++) {
					if (cell.array_direction == "x_axis") {
						skipped_cell_count += this.skip_cells(cell, skipped_cell_count + i)
						this.appendCellData(null, cell.y_coordinate, cell.x_coordinate + skipped_cell_count + i)
					} else if (cell.array_direction == "y_axis") {
						skipped_cell_count += this.skip_cells(cell, skipped_cell_count + i)
						this.appendCellData(null, cell.y_coordinate + skipped_cell_count + i, cell.x_coordinate)
					}
				}
			} else {
				this.appendCellData(null, cell.y_coordinate, cell.x_coordinate)
			}
		},
		openCellDialog(data) {
			const cell = this.cells.find(
				(c) =>
					c.sheet_number == this.selectedSheetId &&
					c.x_coordinate == data.coordinate.xCoordinate &&
					c.y_coordinate == data.coordinate.yCoordinate
			)
			this.existingCell = cell
			this.selectedCell = data.cell
			this.coordinate = data.coordinate
		},
		closeCellDialog() {
			this.selectedCell = null
			this.existingCell = null
			this.coordinate = null
		},
		readExcelData() {
			axios
				.get(this.excel_file.url, {
					responseType: "blob",
				})
				.then(async (res) => {
					const file = new File([res.data], "file1.xlsx", {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
					})
					this.workbook = new Excel.Workbook()
					this.workbook.xlsx
						.load(await file.arrayBuffer())
						.then((res) => {
							this.setExcelData()
						})
						.catch((err) => {
							errorHandling.errorResponse(err)
						})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setExcelData() {
			this.workbook.eachSheet((worksheet, sheetId) => {
				this.sheets.push({
					name: worksheet.name,
					id: sheetId,
				})
			})
			this.setSheet(this.sheets[0]?.name)
		},
		setSheet(name) {
			this.loading = true
			if (this.selectedSheetId) {
				this.resetCellData()
				this.resetMergeCells()
			}
			const sheet = this.workbook.getWorksheet(name)
			this.selectedSheetId = sheet.id
			this.mergedCells = []
			this.columns = []
			this.rows = []
			this.mergedCells = sheet.model.merges
			const excelWithModifyNumber = 8.6
			for (let i = 1; i <= sheet.columnCount; i++) {
				const col = sheet.getColumn(i)
				const width = col.width * excelWithModifyNumber
				this.columns.push({
					width: width,
					hidden: col.hidden,
				})
			}
			for (let i = 1; i <= sheet.rowCount; i++) {
				const row = sheet.getRow(i)
				const height = excelHelper.dpiToPixel(row.height)
				this.rows.push({
					height: height,
					hidden: row.hidden,
					cells: row.model ? row.model.cells : [],
				})
			}
			this.headers = excelHelper.getHeaders(sheet.columnCount)
			this.$nextTick(() => {
				this.setAllCellData()
				this.mergeCells()
			})
		},
		resetCellData() {
			const cells = this.cells.filter((c) => c.sheet_number == this.selectedSheetId)
			cells.forEach((cell) => {
				this.removeCellData(cell)
			})
		},
		appendCellData(name, y, x) {
			try {
				this.$refs[`cell${y}-${x}`][0].cellData = name
			} catch (err) {
				if (name) {
					this.$store.dispatch("setFlash", {
						type: "alert",
						text: "適当するセルが見つかりませんでした。",
					})
				}
			}
		},
		cellData(cells, header) {
			return cells.find((cell) => cell.address.match(/^[A-Z]+/)[0] == header)
		},
		mergeCells() {
			this.mergedCells.forEach((c) => {
				const mergeInfo = excelHelper.mergedCellInfo(c)
				if (mergeInfo.right - mergeInfo.left > 0) {
					this.$refs[`cell${mergeInfo.top - 1}-${mergeInfo.left - 1}`][0].mergeXAxis =
						mergeInfo.right - mergeInfo.left + 1
					this.$refs[`cell${mergeInfo.top - 1}-${mergeInfo.left - 1}`][0].columns = this.columns
				}
				if (mergeInfo.bottom - mergeInfo.top > 0) {
					this.$refs[`cell${mergeInfo.top - 1}-${mergeInfo.left - 1}`][0].mergeYAxis =
						mergeInfo.bottom - mergeInfo.top + 1
				}
			})
		},
		resetMergeCells() {
			this.mergedCells.forEach((c) => {
				const mergeInfo = excelHelper.mergedCellInfo(c)
				if (mergeInfo.right - mergeInfo.left > 0) {
					this.$refs[`cell${mergeInfo.top - 1}-${mergeInfo.left - 1}`][0].mergeXAxis = null
					mergeInfo.right - mergeInfo.left + 1
					this.$refs[`cell${mergeInfo.top - 1}-${mergeInfo.left - 1}`][0].columns = []
				}
				if (mergeInfo.bottom - mergeInfo.top > 0) {
					this.$refs[`cell${mergeInfo.top - 1}-${mergeInfo.left - 1}`][0].mergeYAxis = null
					mergeInfo.bottom - mergeInfo.top + 1
				}
			})
		},
		recordStyle(row) {
			return { height: `${row.height}px` }
		},
		cellExists(cell) {
			return !cell || !cell.master
		},
		confirmSave(event) {
			event.returnValue = "編集中のものは保存されませんが、よろしいですか？"
		},
	},
	computed: {
		isDialogOpen() {
			return this.selectedCell || this.coordinate
		},
		gridContainerWidth() {
			let style = {}
			const columns = []
			const defaultCellSize = 104
			let width = this.columns.reduce((preVal, currentVal, i) => {
				if (this.columns[i].hidden == true) {
					columns.push(0 + "px")
					return preVal
				} else {
					columns.push(currentVal.width ? currentVal.width + "px" : defaultCellSize + "px")
					return preVal + (currentVal.width || defaultCellSize)
				}
			}, 0)
			style.width = width + "px"
			style.gridTemplateColumns = columns.join(" ")
			return style
		},
	},
}
</script>

<style lang="scss" scoped>
.table-wrapper {
	padding: 1rem;
	overflow: scroll;
	max-width: 100vw;
}
.grid-container {
	display: grid;
	border: thin solid grey;
	justify-items: stretch;
	align-content: stretch;
	div {
		padding: 4px;
		font-size: 0.85rem;
		min-height: 20px;
		border: 0.5px solid grey;
		white-space: pre-wrap;
		word-break: break-all;
		&:hover {
			background-color: whitesmoke;
			cursor: pointer;
		}
	}
	.hidden-cell {
		padding: 0px;
		border: none;
		min-height: 0px;
		max-height: 0px;
		min-width: 0px;
		max-width: 0px;
		overflow: hidden;
	}
}
</style>